import {XauditModel} from '../xaudit.model';

export class PatientCaseEndoFinalReportReferrRepDataModel extends XauditModel {
  CaseEndoFinalReportRefRepID: string;
  CaseFinalReportID: string;
  ReportID: string;
  SentDate: Date;
  SentTo: string;
  SentToLabel: string;
  enumReportDeliveryMethodID: string;
}
